import { render, staticRenderFns } from "./SingleConsignmentReturn.vue?vue&type=template&id=7ebb3042&"
import script from "./SingleConsignmentReturn.vue?vue&type=script&lang=js&"
export * from "./SingleConsignmentReturn.vue?vue&type=script&lang=js&"
import style0 from "./SingleConsignmentReturn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleConsignmentReturn.vue"
export default component.exports